import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { GeoLocationData } from '../models/geo-location-data.model';
import {
  getGeoLocation,
  isInitialized,
  isLoadingGeoLocation,
} from '../reducers';

@Injectable()
export class AppStore {
  constructor(private _store: Store<any>) {}

  isInitialized(): Observable<boolean> {
    return this._store.pipe(select(isInitialized));
  }

  getGeoLocation(): Observable<GeoLocationData> {
    return this._store.pipe(select(getGeoLocation));
  }

  isLoadingGeoLocation(): Observable<boolean> {
    return this._store.pipe(select(isLoadingGeoLocation));
  }
}
